module.exports = __webpack_public_path__ + "img/add-photo-sixth-icon.a68821b3.svg";